export var ConferencePlatform;
(function (ConferencePlatform) {
    ConferencePlatform["ZOOM"] = "ZOOM";
})(ConferencePlatform || (ConferencePlatform = {}));
//# sourceMappingURL=service-schedule-policy.dto.js.map